document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-flwd-video]').forEach(function(video) {
    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function(){});
  });

  document.querySelectorAll('[data-flwd-menu-toggle]').forEach(function(toggle) {
    const header = toggle.closest('[data-flwd-header]');
    const menu = header ? header.querySelector('[data-flwd-mobile-menu]') : null;
    if (!menu) return;

    toggle.addEventListener('click', function() {
      const hidden = menu.hasAttribute('hidden');
      if (hidden) {
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        menu.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
